// filepath: /react-app/react-app/src/api/puzzleService.js
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_CHAINLINK_API_URL || "http://localhost:8000/api";

export const fetchPuzzleTitles = async (page = 0, pageSize = 20) => {
  try {
    const response = await axios.get(`${BASE_URL}/puzzle-titles/daily`, {
      params: { page, page_size: pageSize }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching puzzles:", error);
    throw error;
  }
};

export const fetchPuzzle = async (puzzleKey, difficulty) => {
  try {
    const response = await axios.get(`${BASE_URL}/puzzles/${puzzleKey}`, {
      params: { difficulty }
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching puzzle ${puzzleKey}:`, error);
    throw error;
  }
};

export const fetchDailyPuzzle = async (date, difficulty) => {
  try {
    const response = await axios.get(`${BASE_URL}/puzzles/date/${date}`, {
      params: { difficulty }
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching puzzle ${date}:`, error);
    throw error;
  }
};

export const makeGuess = async (puzzleKey, word, encodedState) => {
  try {
    const response = await axios.post(`${BASE_URL}/puzzles/${puzzleKey}/guess`, {
      word,
      encoded_state: encodedState
    });
    return response.data;
  } catch (error) {
    console.error("Error making guess:", error);
    throw error;
  }
};